import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ roles, children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500">
        <div className="data-label">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    const target =
      user.role === "admin"
        ? "/admin"
        : user.role === "surveyor"
          ? "/surveyor"
          : "/candidate";
    return <Navigate to={target} replace />;
  }
  return children;
}
